export interface TributeValue {
  key: string;
  value: string;
  type: TributeValueType;
  uid?: string; // For user mentions
  string?: string; // For Tribute.js lookup
  firstName?: string; // For user mentions
  lastName?: string; // For user mentions
}

export enum TributeValueType {
  ShortCode = 'sc',
  CustomCode = 'cc',
  FillableField = 'ff',
}
